import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ChargerPublicParkingUsagesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.CHARGER_PUBLIC_PARKING_USAGES>();

    const value = values.chargerPublicParkingUsages.value;
    const selection = Object.keys(value)
        .filter(key => value[key as keyof typeof value])
        .sort()
        .join("#");

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Nutzung der Ladeeinrichtung
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.chargerPublicParkingUsages.value = {
                                    allDay: v.indexOf("allDay") >= 0,
                                    whenOpen: v.indexOf("whenOpen") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="allDay"
                            control={<Radio />}
                            label="Laden rund um die Uhr"
                            text="Die Ladeeinrichtung steht durchgängig ohne Einschränkungen zum Laden zur Verfügung."
                            error={values.chargerPublicParkingUsages.error !== null}
                        />
                        <FormControlLabel
                            value="whenOpen"
                            control={<Radio />}
                            label="Laden zu den Öffnungszeiten"
                            text="Die Ladeeinrichtung kann ausschließlich zu bestimmten Öffnungszeiten genutzt werden."
                            error={values.chargerPublicParkingUsages.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
